module.exports = `${require.publicPath}southbay-dark.17462d4f.png`;